<ng-template #replenishmentView let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <div>
            <div class="card-title">
                <h2>{{ 'MODALS.HEADERS.REPLENISHMENT' | translate }}</h2>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <label for="walletTotal">{{ 'MODALS.FIELDS.SUM' | translate }}</label>
                        <input #inputTotal class="form-control form-control-lg form-block" id="walletTotal">
                    </div>
                </div>
                <button (click)="onReplenishmentEvent(inputTotal, modal)"
                        [disabled]="isLockButton"
                        class="btn btn-primary btn-lg btn-block m-2"
                        data-action="createReplenishment"
                        type="submit"><span
                        *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.TOP_UP' | translate }}</span>
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
